module.exports = "/_next/static/media/bcc16111e6f1afe5d953561b7fa53a89.svg";